import type { ICustomerDetail } from '@manager/api/types/customer-types';

export function getFullName(
  item?: Partial<Pick<ICustomerDetail, 'firstname' | 'lastname'>>,
  fallback = '-'
) {
  const fullName = [item?.firstname, item?.lastname]
    .map((name) => name?.trim())
    .filter((name) => name)
    .join(' ');

  return fullName ? fullName : fallback;
}

export function extractNumber(str: string) {
  const regex = /(\d+)/; // Regular expression to match a sequence of digits
  const match = str.match(regex);

  return match ? +match[0] : -1;
}

export function capitalizeFirstLetter(str: string): string {
  if (!str || str.length <= 0 || typeof str !== 'string') return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Extracts the item and field indices from the given string
 * Example input: '0.0.item_distinct'
 * Returns: [0, 0]
 */
export function extractIndices(str: string): [number, number] {
  const regex = /^(\d+)\.(\d+)/;
  const match = str.match(regex);

  return match ? [+match[1], +match[2]] : [-1, -1];
}
